'use client';

import ContentLoader from 'react-content-loader';

const PropertyListShimmer: React.FC = () => {
  return [...Array(4)].map((elementInArray, index) => (
    <div
      key={index}
      className="relative mx-auto w-full bg-white rounded-lg drop-shadow-thumbnail p-2.5"
    >
      <ContentLoader
        speed={2}
        width="100%"
        height="100%"
        viewBox="0 0 318 310"
        backgroundColor="#f0f0f0"
        foregroundColor="#dedede"
        uniqueKey={`property-shimmer-${index}`}
      >
        <rect x="2" y="2" rx="2" ry="2" width="100%" height="172" />
        <rect x="3" y="208" rx="0" ry="0" width="294" height="16" />
        <rect x="6" y="239" rx="0" ry="0" width="170" height="16" />
        <rect x="4" y="281" rx="0" ry="0" width="140" height="16" />
      </ContentLoader>
    </div>
  ));
};

export default PropertyListShimmer;
